import { Modal, Text, TouchableOpacity, View } from "react-native";
import styles from "./styles";
import { MaterialIcons } from "@expo/vector-icons";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import transactionSlipService from "../../services/transactionSlipService";
import AsyncStorage from "@react-native-async-storage/async-storage";
import api from "../../services/api";

const DadosTransacoes = ({ dadosTransferencia = null }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState({});

  const [dados, setDados] = useState({});
  useEffect(() => {
    console.log("ModalTransacoes PROP", dadosTransferencia);
    console.log("ModalTransacoes PROP uuid", dadosTransferencia.result.uuid);
    setDados(dadosTransferencia.result);
    //TODO: obter dados do cliente de destino, api bloqueia 403
    //loadClientData(dadosTransferencia.result.user_id_in);
  }, []);

  const loadClientData = async (user_id) => {
    const authtoken = await AsyncStorage.getItem("JWT_TOKEN");
    api
      .get(`/clients/` + user_id, {
        headers: { Authorization: `Bearer ${authtoken}` },
      })
      .then(async (res) => {
        console.log("Destinatário:", res);
      });
  };

  const loadData = async () => {
    setLoading(true);
    const authtoken = await AsyncStorage.getItem("JWT_TOKEN");
    transactionSlipService
      .get(authtoken)
      .then((response) => {
        if (response.data) {
          const formattedData = response.data.map((item) => {
            let unitPrice = 0;
            if (parseFloat(item.pricegpxbrl) > 0) {
              unitPrice = formatGPXBalance(
                parseFloat(item.pricegpxbrl) / parseFloat(item.amount)
              );
            }

            return {
              token: item.token,
              transferuser: item.transferuser,
              txid: item.txid,
              transaction_label: assets(item.transaction_type),
              transaction_type: item.transaction_type,
              amount: parseFloat(item.amount),
              pricegpxbrl: formatGPXBalance(item.pricegpxbrl),
              unitPrice: unitPrice,
              created_at: formatDate(item.created_at),
              feegpxbrl: formatGPXBalance(item.feegpxbrl),
              feetoken: item.feetoken,
            };
          });
          setData(formattedData);
          if (response.data.length > 0 && openFirst) {
            console.log(formattedData);
            showModal(formattedData[0]);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
    activesService.get(authtoken).then((response) => {
      if (response.data.length > 0) {
        setActives(response.data[0]);
      }
    });
  };

  return (
    <View style={styles.centeredView}>
      <View style={styles.modalView}>
        <View style={styles.modalText}>
          {/* <View style={{ flex: 0.5 }}>
              <MaterialIcons
                onPress={() => shareTransactionSlip()}
                name="share"
                size={25}
                color="black"
                style={styles.share}
              />
            </View> */}
          <Text style={styles.modalTitle}>
            <FormattedMessage id="cardstransactionswallet.comprovanteTransacao" />
          </Text>
          <Text>
            <FormattedMessage id="dadosTransacao.msgComprovanteCompleto" />
          </Text>

          <Text style={styles.modalTextDate}>{modalContent.created_at}</Text>

          {/*  <View style={styles.labelRows}>
              <Text style={styles.valueTransactions}>
                <FormattedMessage id="cardstransactionswallet.token" />
              </Text>
              <Text>{dados.id_token}</Text>
            </View> */}

          <View style={styles.hrLine}></View>

          <View style={styles.labelRows}>
            <Text style={styles.valueTransactions}>
              <FormattedMessage id="cardstransactionswallet.quantidade" />
            </Text>
            <Text>
              {Math.abs(dados.quantity)} {dados.token}
            </Text>
          </View>
          <View style={styles.hrLine}></View>
          {/* {!(
              modalContent?.transaction_type === "transferin" ||
              modalContent?.transaction_type === "transferout" ||
              modalContent?.transaction_type === "deposit" ||
              modalContent?.transaction_type === "withdraw"
            ) && (
              <>
                <View style={styles.labelRows}>
                  <Text style={styles.valueTransactions}>
                    <FormattedMessage id="cardstransactionswallet.valor" />
                  </Text>
                  <Text>
                    {modalContent.pricegpxbrl}{" "}
                    <FormattedMessage id="cardstransactionswallet.gpxBrl" />
                  </Text>
                </View>
                <View style={styles.hrLine}></View>
              </>
            )}

            {!(
              modalContent?.transaction_type === "transferin" ||
              modalContent?.transaction_type === "transferout" ||
              modalContent?.transaction_type === "deposit" ||
              modalContent?.transaction_type === "withdraw"
            ) && (
              <>
                <View style={styles.labelRows}>
                  <Text style={styles.valueTransactions}>
                    <FormattedMessage id="cardstransactionswallet.valorunitario" />
                  </Text>
                  <Text>
                    {modalContent.unitPrice}{" "}
                    <FormattedMessage id="cardstransactionswallet.gpxBrl" />
                  </Text>
                </View>
                <View style={styles.hrLine}></View>
              </>
            )}

            {modalContent.feetoken && modalContent.feetoken > 0 ? (
              <>
                <View style={styles.labelRows}>
                  <Text style={styles.valueTransactions}>
                    <FormattedMessage id="cardstransactionswallet.taxa" />
                  </Text>
                  <Text>
                    {maxDecimals(modalContent.feetoken + "", 8)}{" "}
                    {modalContent.token}
                  </Text>
                </View>
              </>
            ) : (
              <>
                <View style={styles.labelRows}>
                  <Text style={styles.valueTransactions}>
                    <FormattedMessage id="cardstransactionswallet.taxa" />
                  </Text>
                  <Text>
                    {modalContent.feegpxbrl}{" "}
                    <FormattedMessage id="cardstransactionswallet.gpxBrl" />
                  </Text>
                </View>
              </>
            )}
            <View style={styles.hrLine}></View>

            <View style={styles.labelRows}>
              <Text style={styles.valueTransactions}>
                <FormattedMessage id="cardstransactionswallet.tipoTransacao" />
              </Text>
              <Text>
                {modalContent?.transaction_type &&
                  assets(modalContent?.transaction_type)}
              </Text>
            </View>

            <View style={styles.hrLine}></View>

            {(modalContent?.transaction_type === "transferin" ||
              modalContent?.transaction_type === "transferout") && (
              <>
                <View style={styles.labelRows}>
                  <Text style={styles.valueTransactions}>
                    {modalContent?.transaction_type === "transferin" ? (
                      <View>
                        <FormattedMessage id="cardstransactionswallet.remetente" />
                      </View>
                    ) : (
                      <View>
                        <FormattedMessage id="cardstransactionswallet.destinatario" />
                      </View>
                    )}
                    :{" "}
                    <View>
                      <Text>{modalContent?.transferuser}</Text>
                    </View>
                  </Text>
                </View>
                <View style={styles.hrLine}></View>
              </>
            )}
 */}
          <Text
            style={{
              fontSize: 14,
              color: "#000000",
            }}
          >
            <FormattedMessage id="cardstransactionswallet.idTransacao" />{" "}
          </Text>

          <Text style={{ fontSize: 14, color: "#000000" }}>
            {dados.uuid ? dados.uuid : new Date().getTime()}
          </Text>

          <View style={styles.hrLine}></View>

          <View style={styles.idContainer}>
            <Text style={styles.gpxTitle}>
              <FormattedMessage id="cardstransactionswallet.gpxTecInvest" />
            </Text>
            <Text style={styles.gpxCnpj}>
              <FormattedMessage id="cardstransactionswallet.cnpj" />
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default DadosTransacoes;
